var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSprayerV3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 20.75C4.37663 20.75 4.66934 20.6597 4.875 20.4326C5.08643 20.1991 5.25 19.7731 5.25 19C5.25 18.2269 5.08643 17.8009 4.875 17.5674C4.66934 17.3403 4.37663 17.25 4 17.25C3.62338 17.25 3.33066 17.3403 3.125 17.5674C2.91357 17.8009 2.75 18.2269 2.75 19C2.75 19.7731 2.91357 20.1991 3.125 20.4326C3.33066 20.6597 3.62338 20.75 4 20.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20.75C20.3766 20.75 20.6693 20.6597 20.875 20.4326C21.0864 20.1991 21.25 19.7731 21.25 19C21.25 18.2269 21.0864 17.8009 20.875 17.5674C20.6693 17.3403 20.3766 17.25 20 17.25C19.6234 17.25 19.3307 17.3403 19.125 17.5674C18.9136 17.8009 18.75 18.2269 18.75 19C18.75 19.7731 18.9136 20.1991 19.125 20.4326C19.3307 20.6597 19.6234 20.75 20 20.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 10.5625H7.12715C6.90391 10.5625 6.70772 10.7105 6.64639 10.9251L5.81972 13.8185C5.7759 13.9719 5.80788 14.1369 5.9058 14.2628L7.34987 16.1195C7.44459 16.2413 7.59025 16.3125 7.74454 16.3125H16.2755C16.4183 16.3125 16.5543 16.2514 16.6492 16.1447L18.3032 14.2839C18.4246 14.1474 18.4618 13.9556 18.4004 13.7835L17.3685 10.8943C17.2974 10.6953 17.1089 10.5625 16.8976 10.5625H15.75M8.25 10.5625V9.0625C8.25 8.78636 8.47386 8.5625 8.75 8.5625H10C10.2761 8.5625 10.5 8.78636 10.5 9.0625V10.5625M8.25 10.5625H10.5M10.5 10.5625H13.5M15.75 10.5625V9.0625C15.75 8.78636 15.5261 8.5625 15.25 8.5625H14C13.7239 8.5625 13.5 8.78636 13.5 9.0625V10.5625M15.75 10.5625H13.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.5V13C7.5 12.7239 7.72386 12.5 8 12.5H9.5C9.77614 12.5 10 12.7239 10 13V13.5C10 13.7761 9.77614 14 9.5 14H8C7.72386 14 7.5 13.7761 7.5 13.5Z",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12.5H16C16.2761 12.5 16.5 12.7239 16.5 13V13.5C16.5 13.7761 16.2761 14 16 14H14.5C14.2239 14 14 13.7761 14 13.5V13C14 12.7239 14.2239 12.5 14.5 12.5Z",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 14L3.23979 14.452C3.08849 14.4823 2.95964 14.5807 2.89064 14.7187L2.6118 15.2764C2.54142 15.4172 2.54142 15.5828 2.6118 15.7236L2.8618 16.2236C2.9465 16.393 3.11963 16.5 3.30902 16.5H5.2169C5.39254 16.5 5.55529 16.5921 5.64565 16.7428L6.85435 18.7572C6.94471 18.9079 7.10746 19 7.2831 19H16.7169C16.8925 19 17.0553 18.9079 17.1457 18.7572L18.3543 16.7428C18.4447 16.5921 18.6075 16.5 18.7831 16.5H20.691C20.8804 16.5 21.0535 16.393 21.1382 16.2236L21.3388 15.8223C21.4351 15.6298 21.3974 15.3974 21.2452 15.2452L21.0726 15.0726C21.0247 15.0247 20.9676 14.987 20.9047 14.9619L18.5 14",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7969 14L19.2376 12.0545C19.2459 12.0183 19.25 11.9812 19.25 11.9441V5.5C19.25 4.11929 18.1307 3 16.75 3H7.25C5.86929 3 4.75 4.11929 4.75 5.5V11.9441C4.75 11.9812 4.75415 12.0183 4.76236 12.0545L5.20312 14",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2598 12.4088L19.6679 10.6718L23.7842 5.94888M22.5354 4.64871L17.424 10.6879",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5354 4.64871L22.7927 5.67312C22.8019 5.70985 22.8311 5.73822 22.8681 5.74639L23.7842 5.94888",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2981 6.11948L21.5408 7.13948C21.5497 7.17677 21.5791 7.20571 21.6165 7.21398L22.5012 7.40953",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0299 9.97373L18.2726 10.9937C18.2814 11.031 18.3108 11.06 18.3483 11.0682L19.233 11.2638",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2541 7.51292L20.4091 8.50618C20.4155 8.54688 20.4461 8.57951 20.4863 8.5884L21.1825 8.74227",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0193 8.86422L19.218 9.87091C19.2257 9.90989 19.2557 9.94062 19.2945 9.94919L20.085 10.1239",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.74048 12.6938L4.3324 10.9567L0.216094 6.23382M1.46492 4.93366L6.57626 10.9729",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46492 4.93366L1.20759 5.95806C1.19836 5.99479 1.16917 6.02316 1.13218 6.03134L0.216094 6.23382",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.70213 6.40443L2.45949 7.42442C2.45062 7.46171 2.42122 7.49065 2.38379 7.49892L1.49907 7.69447",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97035 10.2587L5.72771 11.2787C5.71884 11.316 5.68944 11.3449 5.65201 11.3532L4.76729 11.5487",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.74622 7.79787L3.59115 8.79113C3.5848 8.83182 3.55415 8.86446 3.51393 8.87334L2.81778 9.02721",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98102 9.14916L4.78231 10.1559C4.77462 10.1948 4.74458 10.2256 4.70579 10.2341L3.91527 10.4089",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10.5C7 7 8 7 12 7C16 7 17 7 17 10.5",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprayerV3);
export default __webpack_public_path__ + "static/media/Sprayer_V3.209e2750e33b6d71168feb9d7c51d33e.svg";
export { ForwardRef as ReactComponent };